module.exports = require("uncontrollable");


//////////////////
// WEBPACK FOOTER
// external "uncontrollable"
// module id = 14
// module chunks = 0